import React, { useState } from 'react';
import '../App.css';

const plans = [
  {
    name: '云服务-基础版',
    priceDeploy: '软件授权与首年部署 ¥68,800',
    priceService: '次年云平台服务 ¥18,800/年',
    features: [
      '全部基础版功能使用授权',
      '站点装修与独立小程序上架',
      '支持AI智能辅助',
      '基础数据采集与报表',
      '支持单机构/单中心',
      '1次在线培训，提供系统使用手册',
      '专属服务群',
    ],
  },
  {
    name: '云服务-专业版',
    priceDeploy: '软件授权与首年部署 ¥168,800',
    priceService: '次年云平台服务 ¥28,800/年',
    features: [
      '全部专业版功能使用授权',
      '小程序装修与独立上架',
      '支持流程设计与专病建库',
      '支持AI副驾驶',
      '支持软著作申请与科研课题申报',
      '支持多中心/多租户',
      '定制开发与API集成（含50人天，超过部分按人天计费）',
      '2次用户培训，提供完整系统使用手册',
      '优先技术支持',
    ],
    highlight: true,
  },
  {
    name: '本地部署-专业版',
    priceDeploy: '软件授权与首年部署 ¥单独评估',
    priceService: '次年远程服务 ¥首年总费用X15%',
    features: [
      '全部专业版功能使用授权',
      '支持本地模型训练和部署',
      '支持流程设计与专病建库',
      '支持AI副驾驶',
      '支持软著申请与科研课题申报',
      '支持多中心/多租户',
      '专属定制开发',
      '支持移动端部署与软件、数据库运行环境搭建',
      '3次用户培训，提供完整系统使用手册',
      '专属服务团队',
      '7x24小时技术支持',

    ],
  },
];

function scrollToAbout() {
  const aboutSection = document.getElementById('about');
  if (aboutSection) {
    aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }
}

function PricingSection() {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [expand, setExpand] = useState([false, false, false]);
  const isMobile = window.innerWidth < 900;
  return (
    <section id="pricing">
      <h2>定价与服务内容</h2>
      <div className="section-subtitle">灵活选择，满足不同医疗机构数字化发展需求</div>
      <div className="cards-row">
        {plans.map((plan, i) => {
          const isActive = hoverIndex === i || (hoverIndex === null && plan.highlight);
          const showAll = !isMobile || expand[i];
          const featuresToShow = showAll ? plan.features : plan.features.slice(0, 5);
          return (
            <div
              className="card"
              key={i}
              onMouseEnter={() => setHoverIndex(i)}
              onMouseLeave={() => setHoverIndex(null)}
              style={isActive
                ? { border: '2.5px solid #009900', boxShadow: '0 6px 32px rgba(0,153,0,0.13)' }
                : {}}
            >
              <div className="card-title" style={{fontSize: '1.25rem', fontWeight: 800, marginBottom: 12}}>{plan.name}</div>
              <div style={{color: '#003300', fontWeight: 700, fontSize: '1.13rem', marginBottom: 2}}>{plan.priceDeploy}</div>
              <div style={{color: '#009900', fontWeight: 700, fontSize: '1.08rem', marginBottom: 18}}>{plan.priceService}</div>
              <ul style={{textAlign: 'left', color: '#444', fontSize: '1rem', lineHeight: 1.85, margin: '0 0 18px 0', padding: 0, listStyle: 'none'}}>
                {featuresToShow.map((f, idx) => (
                  <li key={idx} style={{marginBottom: 8, display: 'flex', alignItems: 'center'}}>
                    <span style={{display: 'inline-block', width: 8, height: 8, background: '#009900', borderRadius: '50%', marginRight: 10}}></span>{f}
                  </li>
                ))}
              </ul>
              {isMobile && plan.features.length > 5 && (
                <button
                  style={{background: 'none', color: '#009900', fontWeight: 700, fontSize: '0.98rem', marginBottom: 8, boxShadow: 'none', border: 'none', padding: 0, width: 'auto'}}
                  onClick={() => setExpand(arr => arr.map((v, idx) => idx === i ? !v : v))}
                  type="button"
                >
                  {expand[i] ? '收起' : '展开全部'}
                </button>
              )}
              <button
                onClick={scrollToAbout}
                style={{
                  background: isActive
                    ? 'linear-gradient(90deg,#009900 0%,#003300 100%)'
                    : '#003300',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  padding: '10px 0',
                  width: '100%',
                  fontWeight: 700,
                  fontSize: '1.08rem',
                  cursor: 'pointer'
                }}
              >
                立即咨询
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
export default PricingSection; 